import {
  AVG_OVERHAUL,
  AVG_REPAIR,
  AVG_TEST,
  AWAITING_REPLY,
  BER_RATE,
  EVALUATION_FEE,
  NO_CAPES,
  REPAIR_QUOTE_LINE_ITEM,
  TURNAROUND_TIME
} from "MODULES/RepairQuotes/constants";

export const clearForNoCapes = (ev, setFieldValue) => {
  const quoteType = ev.target.value;
  if ([NO_CAPES, AWAITING_REPLY].includes(quoteType)) {
    [
      EVALUATION_FEE,
      AVG_OVERHAUL,
      AVG_TEST,
      AVG_REPAIR,
      BER_RATE,
      TURNAROUND_TIME
    ].forEach(f => setFieldValue([REPAIR_QUOTE_LINE_ITEM, f].join("."))(null));
  }
};



// WEBPACK FOOTER //
// ./app/modules/RepairQuotes/helpers.js